module.exports = __webpack_public_path__ + "media/components/VendingCart/assets/shadow-highlight-overlay-7d0527ebe0fa268dde1257213950d218.png";